import {AxiosError} from 'axios';
import {POST_COORDINATOR_SEARCH_ADMIN_APPEAL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

export interface Coordinator {
  coordinatorName: string;
  email: string;
  school: string;
  uuid: string;
}

export interface CoordinatorSearchRequest {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAdminAppealCoordinatorSearch = ({onSuccess, onError}: Input = {}) => {
  const postAdminAppealCoordinatorSearch = async (requestBody: CoordinatorSearchRequest) => {
    const res = await axiosClient.post<Coordinator[]>(
        POST_COORDINATOR_SEARCH_ADMIN_APPEAL,
        requestBody
    );

    return res.data;
  };

  return useCustomMutation(postAdminAppealCoordinatorSearch, {
    onSuccess,
    onError,
  });
};
